import {createApp} from 'vue';
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue';
import router from './router';
import store from './store/index';
import installElementPlus from './plugins/element';

import './assets/css/icon.css';
import './assets/login/css/main.css';
import directives from './utils/directive';
import {include} from './utils/methodUtil';
// 按需引入 dataV 组件（全量引入会编译 decoration3/6 等含 Vue3 不兼容模板的组件，导致构建失败）
import dvFullScreenContainer from '@jiaminghi/data-view/lib/components/fullScreenContainer/index'
import dvBorderBox1 from '@jiaminghi/data-view/lib/components/borderBox1/index'
import dvBorderBox11 from '@jiaminghi/data-view/lib/components/borderBox11/index'
import dvScrollBoard from '@jiaminghi/data-view/lib/components/scrollBoard/index'
import dvLoading from '@jiaminghi/data-view/lib/components/loading/index'
import print from 'vue-print-nb'

const app = createApp(App)
for (let i in ElementPlusIconsVue) {
    app.component(i, ElementPlusIconsVue[i])
}
installElementPlus(app)
directives(app)

//全局自定义指令 v-permission=['页面子级按钮权限的index']
// vue自定义指令传入的值可以是xxPage:xxAbc 只要和 sys_user_menu某页面下的is_button类型=1的按钮的权限的index 相同即可
app.directive('permission', {
    mounted(el, binding) {
        //当前按钮所需要的权限
        const permissionValue = binding.value;
        // console.log('aaaaaaaaaaaa')
        // console.log("存在权限判定:" + permissionValue)
        //当前页面用户所拥有的权限
        let thisPage = JSON.parse(localStorage.getItem('thisPage'));
        if (permissionValue != null && permissionValue.length > 0) {
            if (thisPage != null && thisPage.permission != null && thisPage.permission.length > 0) {
                if (include(thisPage.permission, permissionValue) === true) {
                    return;
                }
            }
        }
        el.style.display = 'none'; // 如果用户没有权限，隐藏按钮
        el.disabled = true; // 禁用按钮
    }
}).use(store).use(router).use(ElementPlus).use(print)
    .use(dvFullScreenContainer)
    .use(dvBorderBox1)
    .use(dvBorderBox11)
    .use(dvScrollBoard)
    .use(dvLoading)
    .mount('#app')


// 注意：原“防止localStorage被修改”的 storage 监听器已移除。
// 原因：storage 事件是跨标签页的，A 标签页登录写入 token/menu 时，B 标签页会收到事件并
// 执行 localStorage.setItem(key, oldValue) 把登录状态还原成旧值(null)，导致登录后 token
// 丢失、路由守卫拦截跳回登录页（表现为“提示登录成功后不跳转”）。多标签页下必现。
// localStorage 本就是页面间共享存储，不应在监听器中回写覆盖。




